import { Component, ElementRef, HostListener, Inject, OnInit, ViewChild, DOCUMENT, AfterViewInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { KeycloakService } from 'keycloak-angular';
import { environment } from '@env/environment';
import { MenuComponent } from './core/menu/menu.component';
import { IconsService } from '@app/core/services/design/icons.service';
import { PmIcons } from '@app/core/services/design/Icons';

import { Title } from '@angular/platform-browser';
import { MaintenanceService } from './core/services/maintenance/maintenance.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit, AfterViewInit {
  title = environment.application.title;
  favicon: string = environment.application.favicon || './assets/images/brand/favicon.png';

  appVersion = environment.version;
  pmIcons = PmIcons;
  isToggle = true;

  // to hide header and footer in maintenance
  maintenanceInProgress: boolean = false;
  // to display banner
  maintenancePlanned: boolean = false;

  @ViewChild(MenuComponent, { static: false }) menuComponent: MenuComponent;
  @ViewChild('content', { static: false }) contentDiv: ElementRef;

  constructor(
    private translate: TranslateService,
    private keycloakService: KeycloakService,
    private _icons: IconsService,
    private titleService: Title,
    @Inject(DOCUMENT) private document: Document,
    private maintenanceService: MaintenanceService
  ) {

  }

  ngOnInit(): void {
    this.initMaintenance();
    this.adjustMainContainer();
    this.autoSizeMenu();

    this.translate.setFallbackLang('fr');
    this.translate.use('fr');

    // Define title
    this.titleService.setTitle(this.title);

    // Define favicon
    this.document.getElementById('appFavicon').setAttribute('href', this.favicon);

    this.registerIcons();
  }

  ngAfterViewInit(): void {
    this.adjustMainContainer();
    this.autoSizeMenu();
  }

  @HostListener('window:resize', ['$event'])
  onResize(_event: any) {
    this.adjustMainContainer();
    this.autoSizeMenu();
  }

  toggleNavSize() {
    const body = this.document.getElementsByTagName('body').item(0);
    if(body.classList.contains('nav-md')) {
      body.classList.remove('nav-md');
      body.classList.add('nav-sm');
      this.isToggle = false;
    } else {
      body.classList.remove('nav-sm');
      body.classList.add('nav-md');
      this.isToggle = true;
    }
  }

  private autoSizeMenu() {
    this.document.getElementsByTagName('body').item(0).classList.remove('nav-md', 'nav-sm');
    if (window.innerWidth < 1360) {
      this.document.getElementsByTagName('body').item(0).classList.add('nav-sm');
      this.isToggle = false;
    } else {
      this.document.getElementsByTagName('body').item(0).classList.add('nav-md');
      this.isToggle = true;
    }
  }

  private adjustMainContainer() {
    if (this.contentDiv && this.contentDiv.nativeElement) {
      const windowSize = window.innerHeight - 50;
      this.contentDiv.nativeElement.style.minHeight = windowSize + 'px';
    }
  }

  logout() {
    const baseUrl = location.origin;
    this.keycloakService.logout(baseUrl).then(() => {});
  }

  registerIcons() {
    this._icons.register(this.pmIcons);
  }

  private initMaintenance() {
    this.maintenanceInProgress = this.maintenanceService.getMaintenanceActivatedSubject();
    this.maintenancePlanned = this.maintenanceService.getShowBannerSubject();

    this.maintenanceService.maintenanceActivated.subscribe(state => {
        this.maintenanceInProgress = state;
    });
    this.maintenanceService.showBanner.subscribe(state => {
        this.maintenancePlanned = state;
    });
  }
}
